import { __awaiter } from "tslib";
import { fetchRecentlyUpdatedArticles } from '../api/fetchRecentlyUploadedImages';
import { filterByDate } from './filterByDate';
export const getRecentlyUpdatedArticlesData = () => __awaiter(void 0, void 0, void 0, function* () {
    const data = yield fetchRecentlyUpdatedArticles();
    const { pages } = data;
    // don't show if we don't have enough pages
    if (pages.length < 3) {
        return null;
    }
    // filter by time
    const items = filterByDate(pages);
    // don't show if we don't have enough recently updated articles
    if (items.length < 3) {
        return null;
    }
    return items;
});
